
export class Analyser {
  LCD_LINE_0: string = "--";
  LCD_LINE_1: string = "--";
}
